import { useCreateDepartmentMutation } from '../../api/api-hooks';
import { DepartmentForm } from './departmentsTypes';
import { Hardware } from '../../api/api-generated';

const useDepartmentsItemCreator = () => {
  const [createDepartment] = useCreateDepartmentMutation();
  return (item: DepartmentForm) => {
    if (!item.company || !item.departmentName)
      return { error: { data: { message: 'Missing required fields' } } };
    // Remove duplicates and null entries from Hardware array
    const hardwareIds: number[] = [];
    const filteredHardware: Hardware[] = item.hardware.filter(
      (h): h is Hardware => {
        if (h === null) return false;
        if (hardwareIds.includes(h.id)) return false;
        hardwareIds.push(h.id);
        return true;
      }
    );
    return createDepartment({
      createDepartmentDto: {
        departmentName: item.departmentName,
        quoteLink: item.quoteLink,
        contactName: item.contactName,
        contactEmail: item.contactEmail,
        contactPhone: item.contactPhone,
        lastContacted: item.lastContacted ? item.lastContacted : undefined,
        expirationDate: item.expirationDate ? item.expirationDate : undefined,
        companyId: Number(item.company.id),
        hardware: filteredHardware,
      },
    });
  };
};

export default useDepartmentsItemCreator;
